<template lang="pug">
.posts-list(
  :class="{'--grid': isGrid }"
)
  template(
    v-for="post in posts"
  )
    component(
      :is="postComponent"
      :key="post.id"
      :post="post"
    )
</template>

<script>
import PostCard from '@/components/post/card/post-card'
import PostListItem from '@/components/post/li/post-list-item'

export default {
  name: 'list-posts',
  props: {
    posts: {
      type: Array, // posts[]
    },
    display: {
      type: String,
      default: 'grid',
    },
  },
  computed: {
    isGrid() {
      return this.display === 'grid'
    },
    postComponent() {
      switch (this.display) {
        case 'li':
          return PostListItem
        case 'grid':
        case 'card':
        default:
          return PostCard
      }
    }
  }
}
</script>

<style lang="sass">
.posts-list
  &.--grid
    display: grid
    grid-gap: 1rem
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr))
    justify-content: center

  > .post-card
    padding-bottom: 100%
</style>
